import { useMemo, useState } from 'react'
import * as RegrasFreteHttp from '../../../../../services/api/https/registration/regras-frete.http'

import { errorHandler } from '../../../../../services/util/error.service'

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  LOADING: 'Carregando',
}

const INITIAL_STATE = {
  faixasKm: [],
  modal: {
    show: false,
    data: null,
  },
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
  globalFilter: '',
}

export default function useFaixasKm() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    return {
      // Actions
      resetState() {
        setState({ ...INITIAL_STATE })
      },

      // Events
      onInit(selectedTp) {
        if (selectedTp === 0)
          return setState(prevState => ({
            ...prevState,
            loadingMessage: LOAD_MESSAGE.NONE,
            errorMessage: 'Selecione um Operador Logístico',
          }))
        setState(prevState => ({
          ...prevState,
          selectedTp: selectedTp,
          loadingMessage: LOAD_MESSAGE.LOADING,
        }))
      },

      loadFaixaKm(selectedTp) {
        RegrasFreteHttp.getFaixaKm(selectedTp)
          .then(faixasKm => {
            setState(prevState => ({
              ...prevState,
              faixasKm,
              loadingMessage: LOAD_MESSAGE.NONE,
            }))
          })
          .catch(error => {
            errorHandler(error)
            setState(prevState => ({
              ...prevState,
              loadingMessage: LOAD_MESSAGE.NONE,
              errorMessage: 'Erro ao carregar regras de faturamento',
            }))
          })
      },

      resetErrorMessage() {
        setState(prevState => ({
          ...prevState,
          errorMessage: null,
          loadingMessage: LOAD_MESSAGE.NONE,
        }))
      },

      onBtnNovo(selectedTp) {
        if (selectedTp === 0)
          return setState(prevState => ({
            ...prevState,
            loadingMessage: LOAD_MESSAGE.NONE,
            errorMessage: 'Selecione um Operador Logístico',
          }))
        setState(prevState => ({ ...prevState, modal: { show: true, data: null } }))
      },

      onModalClose() {
        setState(prevState => ({ ...prevState, modal: { show: false, data: null } }))
      },

      onModalSave(faixaKm) {
        setState(prevState => {
          prevState.modal = { show: false, data: null }
          const index = prevState.faixasKm.findIndex(faixaKmAux => faixaKmAux.id === faixaKm.id)
          if (index !== -1) prevState.faixasKm[index] = faixaKm
          else prevState.faixasKm.unshift(faixaKm)
          prevState.loadingMessage = LOAD_MESSAGE.NONE

          return { ...prevState }
        })
      },

      onDataTableItemClicked(motorista) {
        setState(prevState => ({ ...prevState, modal: { show: true, data: { ...motorista } } }))
      },

      onGlobalFilterChange(value) {
        setState(prevState => ({ ...prevState, globalFilter: value }))
      },
    }
  }, [])

  return { state, localDispatch }
}
